"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShoppingContext = useShoppingContext;
var _react = require("react");
var _shoppingSessionContext = require("./shoppingSessionContext");
function useShoppingContext() {
  return (0, _react.useContext)(_shoppingSessionContext.shoppingSessionContext);
}
